import React, { useState } from 'react';
import { Video, Mic, MicOff, VideoOff, PhoneOff, MessageSquare, Share2, Users, CheckCircle2 } from 'lucide-react';

export const TeleRehabModule: React.FC = () => {
  const [isMuted, setIsMuted] = useState(false);
  const [isVideoOff, setIsVideoOff] = useState(false);
  const [chatInput, setChatInput] = useState('');
  const [messages, setMessages] = useState([
    { sender: 'Dr. Sarah (SLP)', text: 'Hello! Let us start today articulation drill for /r/ sounds.', time: '10:00 AM' }
  ]);

  const handleSendMessage = () => {
    if (!chatInput) return;
    setMessages([...messages, { sender: 'You (Patient/Parent)', text: chatInput, time: '10:02 AM' }]);
    setChatInput('');
  };

  return (
    <div className="p-6 space-y-6 bg-slate-900 text-white rounded-2xl">
      <div className="flex items-center justify-between border-b border-slate-800 pb-4">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-teal-500/20 text-teal-300 text-xs font-bold rounded-full border border-teal-500/30">
            <Video className="w-3.5 h-3.5" /> Module 18: Tele-Rehabilitation & Remote Video Therapy
          </div>
          <h2 className="text-2xl font-black mt-2">HD Encrypted Tele-Speech & Tele-OT Room</h2>
        </div>
        <div className="flex items-center gap-2">
          <span className="px-3 py-1 bg-red-500/20 text-red-400 border border-red-500/30 text-xs font-bold rounded-full flex items-center gap-1.5">
            <span className="w-2 h-2 bg-red-500 rounded-full animate-ping" /> LIVE SESSION
          </span>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        
        {/* Main Video Viewport */}
        <div className="lg:col-span-2 bg-slate-950 rounded-2xl border border-slate-800 p-4 space-y-4 flex flex-col justify-between min-h-[340px]">
          <div className="relative w-full h-64 bg-slate-900 rounded-xl overflow-hidden flex items-center justify-center border border-slate-800">
            {!isVideoOff ? (
              <div className="text-center space-y-2">
                <div className="w-20 h-20 bg-teal-500/20 text-teal-400 rounded-full flex items-center justify-center mx-auto border border-teal-500/30 text-2xl font-black">
                  SLP
                </div>
                <div className="text-sm font-bold text-slate-200">Dr. Sarah Connor (Lead Speech Therapist)</div>
                <div className="text-xs text-teal-400">Stream Status: 1080p 60fps AES-256 Encrypted</div>
              </div>
            ) : (
              <div className="text-slate-500 text-xs font-bold">Camera Turned Off</div>
            )}

            {/* Self Video PIP */}
            <div className="absolute bottom-3 right-3 w-28 h-20 bg-slate-800 rounded-lg border border-slate-700 p-1 flex items-center justify-center text-[10px] text-slate-400">
              Self View
            </div>
          </div>

          {/* Video Call Action Controls */}
          <div className="flex items-center justify-center gap-3 pt-2">
            <button
              onClick={() => setIsMuted(!isMuted)}
              className={`p-3 rounded-full transition ${isMuted ? 'bg-red-600 text-white' : 'bg-slate-800 hover:bg-slate-700 text-slate-200'}`}
            >
              {isMuted ? <MicOff className="w-5 h-5" /> : <Mic className="w-5 h-5" />}
            </button>

            <button
              onClick={() => setIsVideoOff(!isVideoOff)}
              className={`p-3 rounded-full transition ${isVideoOff ? 'bg-red-600 text-white' : 'bg-slate-800 hover:bg-slate-700 text-slate-200'}`}
            >
              {isVideoOff ? <VideoOff className="w-5 h-5" /> : <Video className="w-5 h-5" />}
            </button>

            <button className="p-3 rounded-full bg-slate-800 hover:bg-slate-700 text-slate-200">
              <Share2 className="w-5 h-5" />
            </button>

            <button className="px-5 py-3 rounded-full bg-red-600 hover:bg-red-700 text-white font-bold text-xs flex items-center gap-2 shadow">
              <PhoneOff className="w-5 h-5" /> End Call
            </button>
          </div>
        </div>

        {/* Real-time Therapy Chat & Notes */}
        <div className="bg-slate-950 p-4 rounded-2xl border border-slate-800 flex flex-col justify-between space-y-4">
          <div>
            <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider flex items-center gap-1.5 mb-3">
              <MessageSquare className="w-4 h-4 text-blue-400" /> Therapy Session Chat
            </h3>
            <div className="space-y-3 h-52 overflow-y-auto pr-1">
              {messages.map((m, idx) => (
                <div key={idx} className="p-2.5 bg-slate-900 rounded-xl border border-slate-800 space-y-1">
                  <div className="flex items-center justify-between text-[10px] font-bold text-blue-400">
                    <span>{m.sender}</span>
                    <span className="text-slate-500">{m.time}</span>
                  </div>
                  <p className="text-xs text-slate-200">{m.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex gap-2">
            <input
              type="text"
              value={chatInput}
              onChange={(e) => setChatInput(e.target.value)}
              placeholder="Send message to therapist..."
              className="flex-1 px-3 py-2 bg-slate-900 border border-slate-800 rounded-xl text-xs focus:ring-1 focus:ring-teal-500 focus:outline-none"
            />
            <button
              onClick={handleSendMessage}
              className="px-4 py-2 bg-teal-600 hover:bg-teal-700 font-bold text-xs rounded-xl shadow"
            >
              Send
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};
